import ClientsService from '../../services/clients.service.js';

export const state = {
  clientData: null
};

export const mutations = {
  SET_CLIENT(state, client) {
    state.clientData = client;
  }
};

export const actions = {
  async getClientData({ commit, dispatch }) {
    try {
      const { selectedClientId } = this.state.profile.profileData;
      if (!selectedClientId) {
        return null;
      }
      const { data: clientData } = await ClientsService.getClientData(selectedClientId);
      await dispatch('getClientInfo', clientData.subscriptions);
      commit('SET_CLIENT', clientData);
      return clientData;
    } catch (err) {
      console.error(err);
    }
  },
  async getClientInfo({ dispatch }, subscriptions) {
    try {
      await dispatch('getClientPlan');
      if (subscriptions.users) {
        await dispatch('getClientUsers');
      }
      if (subscriptions.credits) {
        await dispatch('getClientCredits');
      }
    } catch (err) {
      console.error(err);
    }
  },
  async updateClient({ commit, state, dispatch }, data) {
    const { body, notification } = data;
    try {
      const updatedClientData = await ClientsService.updateClient(state.clientData.id, body);
      commit('SET_CLIENT', {
        ...state.clientData,
        updatedClientData
      });
      await dispatch('getClientData');
      dispatch('addNotification', notification);
      return updatedClientData;
    } catch (err) {
      const errorNotification = {
        type: 'error',
        message: `feedback.errors.${notification.fieldToEdit}`,
        show: notification.show
      };
      dispatch('addNotification', errorNotification);
      console.error(err);
    }
  },
  async updateClientLogo({ state, dispatch }, data) {
    const { body, notification } = data;
    try {
      const updateClientLogo = await ClientsService.updateClientLogo(state.clientData.id, body);
      await dispatch('getClientData');
      dispatch('addNotification', notification);
      return updateClientLogo;
    } catch (err) {
      const errorNotification = {
        type: 'error',
        message: `feedback.errors.changeLogo`,
        show: notification.show
      };
      dispatch('addNotification', errorNotification);
      console.error(err);
    }
  }
};
